import ReactDOM from "react-dom";

export const Portal = ({ el, children }) => {
  if (!el) return null;

  //to create a portal, use the createPortal function:
  return ReactDOM.createPortal(<div className="portal">{children}</div>, el);
};
